import { CountryCode, PermissionLevels, Site, } from '@debbie/common/dist/index.js';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useMe, useRole } from '@debbie/cortex/dist/me/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import logo from '../../assets/images/logoneg.svg';
import THEME from '../../theme.js';
import ExclusiveContentInput from '../ExclusiveContentInput.js';
import FileTextIcon from '../Icons/FileText.js';
import HardDriveIcon from '../Icons/HardDrive.js';
import { RefreshCcw } from '../Icons/index.js';
import LogOut from '../Icons/LogOut.js';
import SettingsIcon from '../Icons/Settings.js';
import UserIcon from '../Icons/User.js';
import X from '../Icons/X.js';
import LanguageInput from '../LanguageInput.js';
import UserType from '../UserType.js';
const RightNavStyled = styled.div `
  position: fixed;
  width: ${THEME.NAV_RIGHT_WIDTH}px;
  background-color: #efefef;
  top: 0;
  right: 0;
  height: 100vh;

  header {
    background-color: #f7f7f7;
    padding: ${THEME.GRID_SPACING}px;
    height: ${THEME.NAV_TOP_HEIGHT}px;
  }

  div.content {
    padding: ${THEME.GRID_SPACING}px;
    height: calc(100vh - ${THEME.NAV_TOP_HEIGHT}px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
`;
const countryCodeEmojis = {
    [CountryCode.DK]: '🇩🇰',
    [CountryCode.GL]: '🇬🇱',
    [CountryCode.NO]: '🇳🇴',
    [CountryCode.SE]: '🇸🇪',
};
const RightNav = () => {
    const lang = useSelector((s) => s.lang);
    const rightNavOpen = useSelector((s) => s.rightNavOpen);
    const currentLang = useSelector((s) => s.currentLang);
    const site = useSelector((s) => s.site);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const meRole = useRole();
    const tenant = useTenant();
    React.useEffect(() => {
        document.addEventListener('keydown', onEscapePress);
        return () => document.removeEventListener('keydown', onEscapePress);
    }, []);
    const onEscapePress = (evt) => {
        evt = evt || window.event;
        if (evt.code === 'Escape' && rightNavOpen) {
            c.local.toggleRightNav();
        }
    };
    return (React.createElement(RightNavStyled, null,
        React.createElement("header", null,
            React.createElement(X, { style: {
                    cursor: 'pointer',
                }, onClick: () => {
                    c.local.toggleRightNav();
                } })),
        React.createElement("div", { className: "content" },
            React.createElement("h4", { style: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    margin: '0',
                } },
                me ? `${me.firstName} ${me.lastName}` : '',
                ' ',
                React.createElement(UserType, { role: meRole ? meRole : PermissionLevels.client }, `${meRole && lang.roles[meRole]}`),
                ' '),
            React.createElement("p", { style: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    margin: '0.5em 0',
                    marginBottom: '2em',
                    fontSize: '.8em',
                    opacity: 0.8,
                } },
                React.createElement("span", null, tenant?.countryCode && countryCodeEmojis[tenant.countryCode]),
                ' ',
                me && me.email),
            React.createElement(ExclusiveContentInput, { me: me }),
            React.createElement("p", null,
                React.createElement(LanguageInput, { language: currentLang, onChange: (lang) => c.lang.setLang(lang), availableLanguages: [Lang.da, Lang.en, Lang.sv, Lang.no] })),
            React.createElement(Nav, null,
                site === Site.Caseworker && (React.createElement(React.Fragment, null,
                    React.createElement(Link, { to: "/settings" },
                        React.createElement(NavItem, { onClick: () => {
                                c.local.toggleRightNav();
                            } },
                            React.createElement(SettingsIcon, null),
                            React.createElement("h3", null, lang.navigation.settings),
                            React.createElement("p", null, lang.navigation.settingsDesc))),
                    React.createElement(Link, { to: "/user" },
                        React.createElement(NavItem, { onClick: () => {
                                c.local.toggleRightNav();
                            } },
                            React.createElement(UserIcon, null),
                            React.createElement("h3", null, lang.navigation.user),
                            React.createElement("p", null, lang.navigation.userDesc))),
                    meRole && isAdmin(meRole) && (React.createElement(React.Fragment, null,
                        React.createElement(Link, { to: "/tenant-billing" },
                            React.createElement(NavItem, { onClick: () => {
                                    c.local.toggleRightNav();
                                } },
                                React.createElement(FileTextIcon, null),
                                React.createElement("h3", null, lang.navigation.settingsTenantBilling),
                                React.createElement("p", null, lang.navigation.settingsTenantBillingDesc))),
                        React.createElement(Link, { to: "/developers" },
                            React.createElement(NavItem, { onClick: () => {
                                    c.local.toggleRightNav();
                                } },
                                React.createElement(HardDriveIcon, null),
                                React.createElement("h3", null, lang.navigation.settingsDevelopers),
                                React.createElement("p", null, lang.navigation.settingsDevelopersDesc))))))),
                React.createElement(Link, { to: "/account-selector" },
                    React.createElement(NavItem, { onClick: () => {
                            c.local.toggleRightNav();
                        } },
                        React.createElement(RefreshCcw, null),
                        React.createElement("h3", null, lang.navigation.settingsSwitchAccount),
                        React.createElement("p", null, lang.navigation.settingsSwitchAccountDesc)))),
            React.createElement("p", { onClick: () => {
                    c.auth.logout();
                }, style: {
                    marginTop: '1.5em',
                    cursor: 'pointer',
                } },
                React.createElement(LogOut, { style: { margin: '-0.1em 0' } }),
                " ",
                lang.auth.logout),
            React.createElement("br", null),
            React.createElement("a", { href: "https://www.debbiecollect.com" },
                React.createElement("p", { style: {
                        textAlign: 'center',
                    } },
                    React.createElement("img", { style: {
                            width: '40%',
                        }, src: logo }))))));
};
export default RightNav;
const Nav = styled.div `
  svg {
    width: 30px;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;
const NavItem = styled.div `
  padding: ${THEME.GRID_SPACING / 2}px;
  font-size: 0.8em;
  position: relative;
  user-select: none;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid lightgrey;
  margin-bottom: -1px;

  &:first-child {
    border-top: 1px solid lightgrey;
  }

  &:hover {
    &::before {
      content: '';
      position: absolute;
      height: 7px;
      width: 7px;
      background-color: lightgrey;
      border-radius: 100%;
      top: 25px;
      left: 4px;
    }
  }

  svg {
    position: absolute;
    top: 20px;
    left: 16px;
    height: 15px;
    width: 15px;
  }

  & > p,
  & > h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 35px;
    margin: 0 0em;
  }
`;
//# sourceMappingURL=RightNav.js.map